import { memo } from 'react';
import MainLayoutTrialNotif from './MainLayoutTrialNotif';
import MainLayoutResubscribeNotif from './MainLayoutResubscribeNotif';

const MainLayoutNotif = () => {
  return (
    <>
      <MainLayoutTrialNotif />
      <MainLayoutResubscribeNotif />
    </>
  );
};

export default memo(MainLayoutNotif);
